import React, {useEffect} from 'react'
import {BasicLayout} from '../../modules/Layouts/basicLayout'
import {useHistory, useLocation} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import {bindActionCreators} from 'redux'
import PrivateRoute from '../../routes/PrivateRoute'
import GeneracionSujetoExcluido from './GeneracionSujetoExcluido.page'
import ResumenFacturaSujetoExcluido from './ResumenFacturaSujetoExcluido.page'
import {actionSujetoExcluidoCliente, actionSujetoExcluidoEmision} from '../../actions/action-creators'
import { docsDatosReceptorReset, setActiveModuleDoc } from '../../actions/documentos/documentos.actions'
import { State } from '../../reducers'
import ModalSalir from '../../components/Modals/Generales/ModalConfirmSalir'
import { handleRestartStateFormaPago } from '../../actions/forma-pago.actions'

const SujetoExcluidoIndex = () => {
  const datosFacturaRes = useSelector((state:State) => state.sujetoExcluido.datosFacturaRes)
  const {sucursalesCargadas, catalogoSucursal} = useSelector((state:State) => state.sujetoExcluido)
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const {sujetoExcluidoConsultarCatalogos} = bindActionCreators(actionSujetoExcluidoCliente, dispatch)
  const {sujetoExcluidoClearAll} = bindActionCreators(actionSujetoExcluidoEmision, dispatch)

  useEffect(() => {
    if(datosFacturaRes?.JsonFactura) history.push("/otros-documentos/sujeto-excluido/resumen")
    sujetoExcluidoConsultarCatalogos()
    window.scroll(0, 0)
    dispatch(setActiveModuleDoc({idDoc: '14', title: 'Factura Sujeto Excluido'}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    window.scroll(0, 0)
    let url = location.pathname.toLowerCase()
    if (url.includes('/otros-documentos/sujeto-excluido/')) {
      if (url === '/otros-documentos/sujeto-excluido/formulario' || url === '/otros-documentos/sujeto-excluido/resumen') return
    }
    history.push('/404')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  return (
    <BasicLayout>
      <ModalSalir
        excludeValidate={sucursalesCargadas && (!catalogoSucursal || catalogoSucursal.length === 0)} 
        title='Salir de factura de sujeto excluido' 
        onConfirmExit={() => {sujetoExcluidoClearAll(true); dispatch(docsDatosReceptorReset()); dispatch(handleRestartStateFormaPago())}}
        includeText='/sujeto-excluido/'
      />
      <PrivateRoute exact path='/otros-documentos/sujeto-excluido/formulario' component={GeneracionSujetoExcluido}/>
      <PrivateRoute exact path='/otros-documentos/sujeto-excluido/resumen' component={ResumenFacturaSujetoExcluido} />
    </BasicLayout>
  )
}

export default SujetoExcluidoIndex
